var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWaterfowl = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 131,
    viewBox: "0 0 207 131",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F7",
    fillRule: "evenodd",
    d: "M5.072 46.303c-19.152 24.396 17.188 95.163 107.302 82.262 90.115-12.9 71.014 3.053 88.807-38.788 17.793-41.84-10.552-72.727-84.783-86.232C42.166-9.96 24.223 21.906 5.072 46.303z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWaterfowl, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/waterfowl.8b579d1f.svg";
export { ForwardRef as ReactComponent };